import React, { useState, useRef, useEffect } from 'react';
import '../dropdown.css';
import DropDownItem from './dropDownItem';
import LabelInput from '../labelInput/labelInput';
import SelectedItems from './selectedItems';
import {handleValidateObj} from "../../objValues/objvalues";

const list = [{ name: 'No Data Found', id: 0 }];

const DropDownInput = ({
  label = 'label',
  data = list,
  multipule = false,
  disabled = false,
  required = false,
  value = '',
  isBottom = false,
  errorMsg,
  getIdValue,
  getValueById,
  selectedList = [],
  isStarRequired = false,
  controlledValue,
  hideLabel = false
}) => {
  const [updatedData, setUpdatedData] = useState(data);
  const [listData, setListData] = useState('');
  const [inputVal, setInputVal] = useState({ id: null, value: '' });
  const [isShow, setIsShow] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);
  const [selectedValue, setSelectedValue] = useState([]);
  const [isError, setIsError] = useState(false);
  const ref = useRef();
  const listItems = useRef();
  const selectedItems = useRef();

  useEffect(() => {
    if (data && data.length) {
      const newData = data.map((item, index) => ({
        ...item,
        idIndex: index,
      }));
      setUpdatedData(newData);
    }
  }, [data]);

  useEffect(() => {
    if (controlledValue === null) {
      setInputVal({ value: "", id: "" });
    }
  }, [controlledValue])

  const handleSearch = () => {
    const search = updatedData.filter(
      (item) =>
        item.name.toLowerCase().indexOf(inputVal?.value.toLowerCase()) !== -1
    );
    if (multipule) {
      const multiSearch = search.filter((item1) => {
        return !selectedValue.find((item2) => {
          return item1.name.toLowerCase() === item2.name.toLowerCase();
        });
      });
      setListData(multiSearch);
    } else {
      setListData(search);
    }
    if (!search.length) {
      setListData([
        { name: 'Search Not found.', id: 0, disabled: true },
      ]);
    }
  };

  useEffect(() => {
    if (selectedList.length > 0) {
      setSelectedValue(selectedList);
      handleSearch();
    }
  }, [selectedList]);

  useEffect(() => {
    if (isRefresh) {
      handleSearch();
      setTimeout(() => {
        setIsRefresh(false);
      }, 1000);
    }
  }, [isRefresh]);

  const handleInputFocus = () => {
    if (inputVal?.value != null && inputVal?.value.length > 0) {
      const isRest = updatedData.filter(
        (item) =>
          item.name.toLowerCase().indexOf(inputVal?.value.toLowerCase()) === -1
      );
      setListData(isRest);
    }
  };

  const handleListClick = (val = null, id, index) => {
    if (multipule === true) {
      setSelectedValue([...selectedValue, ...listData.splice(index, 1)]);
      setTimeout(() => {
        setInputVal({ value: '', id: null });
        setIsRefresh(true);
        handleSearch();
        ref.current.focus();
      }, 300);
    } else {
      if (val && val.length) {
        setTimeout(() => {
          setInputVal({ value: val, id: id });
        });
        getIdValue({ value: val, id: id });
      } else {
        getIdValue({ value: '', id: '' });
      }
      setTimeout(() => setIsShow(false), 250);
    }
  };

  const handleOutsideClick = (e) => {
    if (
      ref.current &&
      !ref.current.contains(e.target) &&
      listItems.current &&
      !listItems.current.contains(e.target)
    ) {
      if (multipule === true) {
        if (selectedItems.current && !selectedItems.current.contains(e.target))
          setIsShow(false);
        if (inputVal.length === 0) {
          setInputVal({ value: '', id: null });
          setIsRefresh(true);
        }
      }
    }
  };

  useEffect(() => {
    if (listData && listData.length && listData[0]?.disabled)
      ref.current.addEventListener('blur', () =>
        setInputVal({ value: '', id: null })
      );
  }, [listData]);

  const handleSelected = (itemIndex, index) => {
    listData.splice(itemIndex, 0, selectedValue[index]);
    setListData([...listData]);
    selectedValue.splice(index, 1);
    setTimeout(() => {
      setIsShow(true);
      ref.current.focus();
      handleSearch();
    }, 300);
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, []);

  const handleInputBlur = (e) => {
    setTimeout(() => {
      setIsShow(false);
    }, 300);
    const isNotEmpty = handleValidateObj(inputVal);
    if (isNotEmpty === false) {
      setInputVal({ value: '', id: null });
      getIdValue({ value: '', id: '' });
    }
    if (!multipule) {
      if (inputVal.length === 0 || inputVal === undefined) {
        setIsError(true);
      }
    } else {
      if (selectedValue.length === 0 || selectedValue === undefined) {
        setIsError(true);
      } else {
        setIsError(false);
      }
    }
  };

  useEffect(() => {
    if (inputVal?.value != null && inputVal?.value.length) {
      setIsError(false);
    }
    if (multipule) {
      if (getIdValue && selectedValue.length !== 0) {
        getIdValue([...selectedValue]);
      }
    }
  }, [inputVal, selectedValue]);

  useEffect(() => setInputVal({ value: value, id: null }), [value]);
  useEffect(() => {
    let res = data.find((obj) => {
      return obj.id === getValueById;
    });
    if (res) {
      setInputVal({ value: res.name, id: res.id });
    }
  }, [getValueById, data]);

  return (
    <div
      className={`form-group dropdown-box ${
        multipule ? 'multipule-group align-items-center' : ''
      }`}
    >
      {multipule === true ? (
        <SelectedItems
          ref={selectedItems}
          selectedValue={selectedValue}
          handleSelected={handleSelected}
        />
      ) : null}
      <LabelInput
        ref={ref}
        inputValue={inputVal?.value}
        className={`dropdown-val ${
          isShow || (inputVal?.value != null && inputVal?.value.length) || selectedValue.length
            ? ''
            :
              (required && required == 1 )? 'activeAnkInput empty' : ''
              
        }
      
        `}
        handleChange={(e) => setInputVal({ value: e.target.value, id: null })}
        onFocus={() => {
          handleSearch();
          handleInputFocus();
          setIsShow(true);
        }}
        onBlur={handleInputBlur}
        onKeyUp={handleSearch}
        label={label}
        type="text"
        errorMsg={errorMsg}
        disabled={disabled}
        required={required}
        isError={isError}
        isStarRequired={isStarRequired}
        hideLabel={hideLabel}
      />
      <ul
        ref={listItems}
        style={{ display: isShow ? 'block' : 'none' }}
        className={`custom-dropdown scrollbar-styling ${
          multipule ? 'multiple-select' : ''
        } ${isBottom ? 'to-bottom' : ''}`}
      >
        {listData && listData.length ? (
          listData.map((item, index) => {
            return (
              <DropDownItem
                handleListClick={handleListClick}
                title={item.name}
                key={index}
                idIndex={item.idIndex}
                index={index}
                id={item.id}
                disabled={item.disabled}
              />
            );
          })
        ) : (
          <li></li>
        )}
      </ul>
    </div>
  );
};

export default DropDownInput;
